import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MsalProviderCustom from './components/MsalProviderCustom';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MsalProviderCustom>
        <AuthProvider>
          <App />
          <ToastContainer />
        </AuthProvider>
      </MsalProviderCustom>
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals();
